<template>
  <div class="space-y-8">
    <div class="space-y-4">
      <h1 class="text-xl font-medium">Totals</h1>
      <TableGenderAge
        v-if="metric.name === 'page_fans_gender_age'"
        :metric="metric"
        :insights="totalByCategory"
      />
      <table v-else class="table-fixed w-full">
        <thead class="text-sm">
          <tr>
            <th class="border border-gray-200 px-4 py-2">Category</th>
            <th class="border border-gray-200 px-4 py-2 w-32 text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in totalByCategory" :key="`${metric.name}:${row.label}`">
            <td class="border border-gray-200 px-4 py-2">
              {{ row.label }}
            </td>
            <td class="border border-gray-200 px-4 py-2 text-right">
              {{ row.value }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { orderBy } from 'lodash-es';
import TableGenderAge from './metric-gender-age-table-view.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    TableGenderAge,
  },
  props: {
    metric: {
      type: Object,
      required: true,
    },
    values: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalByCategory() {
      const totalByCategory = this.values.reduce((carry, current) => {
        const newTotalByCategory = {};

        Object.keys(current.value).forEach((category) => {
          Object.assign(newTotalByCategory, {
            [category]: (carry?.[category] || 0) + current.value[category],
          });
        });

        return {
          ...carry,
          ...newTotalByCategory,
        };
      }, {});

      return orderBy(
        Object.keys(totalByCategory).map((label) => ({
          label: label.replaceAll('_', ' '),
          value: totalByCategory[label],
        })),
        ['value'],
        ['desc']
      );
    },
  },
};
</script>
